export const DEFAULT_FONT_SIZES = [
  '14px',
  '16px',
  '18px',
  '20px',
  '22px',
  '24px',
  '26px',
  '28px',
  '30px',
  '32px',
  '34px',
  '36px',
  '38px',
  '40px',
  '42px',
  '44px',
  '46px',
  '48px',
  '50px',
  '52px',
  '54px',
  '56px',
  '60px',
  '64px',
  '70px',
  '72px',
  '80px',
  '88px',
  '96px',
  '104px',
  '112px',
  '120px',
  '128px',
];
